// Renders a QR code to a canvas via the bundled `qrcode` lib (no network). The
// modules stay high-contrast dark-on-white regardless of theme so a camera can
// always read it.

import { useEffect, useRef } from 'react';

import QRCode from 'qrcode';

interface Props {
  text: string;
  size?: number;
}

export function QrShow({ text, size = 220 }: Props) {
  const ref = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    void QRCode.toCanvas(canvas, text, {
      width: size,
      margin: 1,
      color: { dark: '#0b0f14', light: '#ffffff' },
    }).catch(() => {
      /* a too-long payload or a stale canvas — the paste code stays available */
    });
  }, [text, size]);

  return <canvas ref={ref} width={size} height={size} className="bz-link-qr" aria-label="Device-link QR code" />;
}
